import { RadioGroup, Box } from '@machobear/design-system'
import { useField } from 'formik'
import { useRef } from 'react'
import useFocusOnError from '@/hooks/use-focus-on-error'

export const FieldRadioGroup = (props: {
  name: string
  label: string
  onChange?: any
  required?: boolean
  disabled?: boolean
  children: any
}) => {
  const fieldRef = useRef<HTMLDivElement>(null)
  const [field, meta] = useField(props.name)
  const { onChange: formikOnChange } = field

  useFocusOnError({ fieldRef, name: props.name })
  const onChangeField = (e: any) => {
    // props.onChange(e)
    formikOnChange(e)
  }

  return (
    <Box ref={fieldRef}>
      <RadioGroup
        id={props.name}
        {...props}
        {...field}
        onChange={onChangeField}
        message={meta.error && meta.touched ? meta.error : undefined}
        tone={meta.error && meta.touched ? 'critical' : undefined}
      >
        {props.children}
      </RadioGroup>
    </Box>
  )
}
